// extracted by mini-css-extract-plugin
export default {"date":"AuctionActivityDateHeadline_date__d1PDA"};